import { Info } from 'lucide-react';
import { Tooltip } from '../../../components/common/Tooltip';
import HoverPillButton from '../../../components/common/HoverPillButton';

type Props = {
  /** 設定済みの名前 (未設定なら null/undefined) */
  currentName?: string | null;
  onClick: () => void;
};

/**
 * 商品画像スロット左下の「名前」編集ボタン (i アイコン)。
 * SlotActionButtons (差替・削除) と同じホバー表示パターンで、
 * Amazon / マニュアル商品詳細ページで共用する。
 */
export function ImageNameButton({ currentName, onClick }: Props) {
  const tooltip = currentName ? `名前: ${currentName}` : '画像の名前を設定';
  return (
    <Tooltip content={tooltip} className="image-name-corner-wrapper">
      <HoverPillButton
        variant="default"
        label="名前"
        icon={<Info size={14} />}
        ariaLabel="画像の名前を編集"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      />
    </Tooltip>
  );
}
